import React, { FC, useContext } from 'react';
import {
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  TableContainer,
  makeStyles,
  MenuItem,
  Select,
  ListItemText,
  Checkbox
} from '@material-ui/core';
import { HeaderRow, TableCellHead, TableCustom } from 'components/Table';
import { dummyInvoice, dummyInvoiceMovement, dummyZone } from 'utils/dummy';
import BodyRow from './components/BodyRow';
import useRole from 'hooks/useRole';
import TypeUser from 'typings/enum/TypeUser';
import { CurrentUserContext } from 'contexts/CurrentUserContext';

interface Props {
  isLoadingData: boolean;
  invoicesMovement: InvoiceMovementModel[];
  queryString?: string;
  order: 'asc' | 'desc';
  orderBy: string;
  setOrder: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  handleConfirmationDelete: (id: number) => React.MouseEventHandler;
  handleOnUpdate: (id: number) => void;
}

const useStyles = makeStyles({
  cellStartId: {
    width: '10%'
  },
  cellTable: {
    width: '17%'
  },
  cellTable3: {
    width: '13%'
  },
  selectStatus: {
    width: '150px'
  }
});

const InvoiceTable: FC<Props> = props => {
  const { currentUser } = useContext(CurrentUserContext);

  const classes = useStyles();

  const { isLoadingData, invoicesMovement, order, orderBy, setOrder, setOrderBy, queryString, handleConfirmationDelete, handleOnUpdate } = props;

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const isSuperVisor = useRole({
    type: (currentUser && currentUser.type) || 'SUPERVISOR',
    allowed: ['SUPERVISOR']
  });
  const adminInvoice = useRole({
    type: (currentUser && currentUser.type) || TypeUser.ADMIN03,
    allowed: [TypeUser.ADMIN03]
  });

  return (
    <TableContainer>
      <TableCustom>
        <TableHead>
          <HeaderRow
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headers={[
              { id: 'name', label: 'RUTE', sort: true },
              { id: 'date', label: 'Tanggal', sort: true, align: 'center' },
              { id: 'action', label: 'Aksi', sort: true, align: 'right' }
            ]}
          />
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            [0, 1, 2, 3].map(index => (
              <BodyRow
                key={index}
                isLoading={isLoadingData}
                invoicesMovement={dummyInvoiceMovement}
                onDelete={handleConfirmationDelete(0)}
                onUpdate={handleOnUpdate}
              />
            ))
          ) : invoicesMovement && invoicesMovement.length > 0 ? (
            invoicesMovement.map((value, index) => (
              <BodyRow
                key={index}
                isLoading={isLoadingData}
                invoicesMovement={value}
                onDelete={handleConfirmationDelete(value.id)}
                onUpdate={handleOnUpdate}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align='center'>
                {queryString ? 'No matching result' : 'Data Tidak Tersedia.'}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default InvoiceTable;
